import React, { useEffect } from "react";
import WOW from "wowjs";
import "animate.css";
import image6 from "../Assets/Images/06.svg";
import image7 from "../Assets/Images/07.svg";
import image8 from "../Assets/Images/08.svg";
import hotel1 from "../Assets/Images/2.jpg";
import hotel2 from "../Assets/Images/3.jpg";
import hotel3 from "../Assets/Images/5.jpg";
import Layout from "../Components/Layout";
function AboutusNew({ onLogout }) {
  useEffect(() => {
    new WOW.WOW({
      live: false, // Disable live updates (improves performance)
    }).init();
  }, []);

  return (
    <>
      <Layout logout={onLogout}>
        <section>
          <div className="container">
            <div className="row mb-5">
              <div className="col-xl-10 mt-4 mx-auto text-center wow animate__animated animate__fadeInDown">
                <h2 className="text-dark">
                  Haramayn Rooms- Largest Market Place to Search Hotel Rooms in
                  Makkah and Madina
                </h2>
                {/* <div className="hstack mt-3 gap-3 flex-wrap justify-content-center">
					<h6 className="bg-mode shadow rounded-2 fw-normal d-inline-block py-2 px-4">
						<img src={image6} className="h-20px me-2" alt=""/>
						14K+ Global Customers
					</h6>

					<h6 className="bg-mode shadow rounded-2 fw-normal d-inline-block py-2 px-4">
						<img src={image7} className="h-20px me-2" alt=""/>
						10K+ Happy Customers
					</h6>

					<h6 className="bg-mode shadow rounded-2 fw-normal d-inline-block py-2 px-4">
						<img src={image8} className="h-20px me-2" alt=""/>
						1M+ Subscribers
					</h6>
				</div> */}
              </div>
            </div>

            <div className="row g-4 about-us-img align-items-center">
              <div className="col-md-6 wow animate__animated animate__slideInLeft">
                <img src={hotel1} className="rounded-3" alt="img" />
              </div>

              <div className="col-md-6 wow animate__animated animate__slideInRight">
                <div className="row g-4">
                  <div className="col-md-8">
                    <img src={hotel2} className="rounded-3" alt="img" />
                  </div>

                  <div className="col-12">
                    <img src={hotel3} className="rounded-3" alt="img" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="pt-0 pt-lg-5">
          <div className="container">
            <div className="row mb-4 mb-md-5 wow animate__animated animate__fadeInUp">
              <div className="col-md-12 mx-auto">
                <h4 className="mb-1 ">About Haramayn Rooms</h4>
                <p style={{ fontSize: "medium" }} className="mb-0">
                  Haramayn Rooms is your trusted online platform for discovering
                  and booking the best hotels with ease. From budget-friendly
                  stays to premium properties, we make it simple for travelers
                  to compare options, find the right match, and instantly book
                  at competitive rates.
                </p>
              </div>
              <div className="col-md-12 mx-auto">
                <h4 className="mb-1 ">Wide Network of Hotels</h4>
                <p style={{ fontSize: "medium" }} className="mb-0">
                  With a strong network of hotels across Makkah, Madinah, and
                  other key destinations, we focus on delivering convenience and
                  comfort for every traveler. Whether you’re planning a short
                  getaway, a family vacation, or a business trip, our platform
                  ensures a smooth booking experience tailored to your needs.
                </p>
              </div>
              <div className="col-md-12 mx-auto">
                <h4 className="mb-1 ">Technology & Customer Support</h4>
                <p style={{ fontSize: "medium" }} className="mb-0">
                  At Haramayn Rooms, we combine technology, reliability, and
                  customer support to give you peace of mind while planning your
                  journey. Our goal is to make travel stress-free, accessible,
                  and enjoyable—helping you focus on the moments that matter
                  most.
                </p>
              </div>
              <div className="col-md-12 mx-auto">
                <h4 className="mb-1 ">How we started our journey?</h4>
                <p style={{ fontSize: "medium" }} className="mb-0">
                  Haramayn Rooms was established few years back with an aim of
                  providing the best services to the hotel management and
                  agents. Main idea behind the startup was to offer a
                  no-compromise user experience for the agents to book hotel
                  rooms with ease. It contains all the types of rooms available
                  in various partner hotels and agents can make selection
                  according to their customers requirements.
                </p>
              </div>
              <div className="col-md-12 mx-auto">
                <h4 className="mb-1 mt-2">
                  Top Management organizing an efficient team
                </h4>
                <p style={{ fontSize: "medium" }} className="mb-0">
                  At Haramayn Rooms, management and team has rich experience of
                  working from many years and knowledge of technology and
                  hospitality services. Our services are delivered to let the
                  mid sized and large hotel agents handle operational challenges
                  and do customer bookings with ease. Due to an effective idea,
                  cost efficiency and an easy to adopt solution, more and more
                  agents are joining our Haramayn Rooms platform to make an easy
                  booking for the required rooms.
                </p>
              </div>
              <div className="col-md-12 mx-auto">
                <h4 className="mb-1 mt-2">Our Target Audience</h4>
                <p style={{ fontSize: "medium" }} className="mb-0">
                  All the worldwide agents who are looking hotel rooms for their
                  customers in Makkah and Madina must opt for the fastest
                  growing Haramayn Rooms portal to achieve their targets easily
                  and book rooms for their customers conveniently. We offer all
                  the room types available in our partner hotels and agents from
                  various regions having different requirements can make use of
                  the large range of options and can finalize their room
                  bookings.
                </p>
              </div>
              <div className="col-md-12 mx-auto">
                <h4 className="mb-1 mt-2">100% Customer Satisfaction</h4>
                <p style={{ fontSize: "medium" }} className="mb-0">
                  With an efficient and dedicated team, Haramayn Rooms has
                  achieved an explosive growth with 100% customer satisfaction
                  and we aim to have many more agents as well as their customers
                  join us in the coming years. We believe that nothing is
                  impossible and we are working to achieve our target by making
                  our presence felt globally to make bookings easier in Makkah
                  and Madina.
                </p>
              </div>
            </div>

            {/* <div className="row g-4">
			<div className="col-sm-6 col-lg-3">
				<div className="icon-lg bg-orange bg-opacity-10 text-orange rounded-2"><i className="fa-solid fa-dollar fs-5"></i></div>
				<h5 className="mt-2">Best Price Guarantee</h5>
				<p className="mb-0">Haramayn Rooms has partnered with more than 500 hotels in Makkah and Madina and connected with more than 10 3rd party APIs for Worldwide hotels. We guarantee the best prices for all the deals available to the agents. Our partnered hotels on the other hand have an opportunity to get viewed by thousand of agents all around the world.</p>
			</div>

			<div className="col-sm-6 col-lg-3">
				<div className="icon-lg bg-success bg-opacity-10 text-success rounded-2"><i className="fa-solid fa-hotel fs-5"></i></div>
				<h5 className="mt-2">How to book Hotel Rooms?</h5>
				<p className="mb-0">Haramayn Rooms offer you hotel rooms search with price comparisons. Prices given at Haramayn Rooms website comes from partner hotels and 3rd party APIs. You can search desired room for clients from list of hotel rooms available by just specifying requirements in 1 click.</p>
			</div>

			<div className="col-sm-6 col-lg-3">
				<div className="icon-lg bg-primary bg-opacity-10 text-primary rounded-2"><i className="fa-solid fa-globe-americas fs-5"></i></div>
				<h5 className="mt-2">Why Choose Us?</h5>
				<p className="mb-0">Haramayn Rooms provides a complete list of options, and you can decide the best room according to client needs. Booking process gets completed by taking all requirements and offering cheap hotel rates through deal hotel room deals in Makkah, Madina and all over the world.</p>
			</div>

			<div className="col-sm-6 col-lg-3">
				<div className="icon-lg bg-info bg-opacity-10 text-info rounded-2"><i className="fa-solid fa-headphones fs-5"></i></div>
				<h5 className="mt-2">Need Help?</h5>
				<p className="mb-0">if you need any help during your hotel rooms search, our team is available to help and provide support 24/7. You just need to contact us to make a confirm booking for your client and gain the status of a reliable agent. Try Haramayn Rooms to book cheap hotel rooms now.</p>
			</div>
		</div> */}
          </div>
        </section>
      </Layout>
    </>
  );
}

export default AboutusNew;
